module.exports = __webpack_public_path__ + "static/9-UNDERSTANDING-THE-FUTURE-OF-WORK-84790094ed3a66a479bb520f506870d8.png";